// extracted by mini-css-extract-plugin
export default {"icon":"HistoryItemIcon__icon___oNWLV"};